"use strict";

exports.__esModule = true;
exports.ChangePartProcessActionElement = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Timeline = require("../../Timeline");
var _ChangePartFeatureDialog = require("../Dialogs/ChangePartFeatureDialog");
var _ManualEventsContext = require("../../Operator/ManualEventsContext");
var _Translator = require("../../Core/Translator");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var ChangePartProcessActionElement = exports.ChangePartProcessActionElement = function ChangePartProcessActionElement(props) {
  // state
  var _useState = (0, _react.useState)(false),
    isDialogOpen = _useState[0],
    setIsDialogOpen = _useState[1];
  // context
  var _React$useContext = _react["default"].useContext(_ManualEventsContext.ManualEventsContext),
    changePartProcess = _React$useContext.changePartProcess;
  var _React$useContext2 = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext2.translate;
  var toggleDialog = function toggleDialog() {
    setIsDialogOpen(!isDialogOpen);
  };
  var invoke = function invoke() {
    setIsDialogOpen(true);
  };
  var childProps = {
    invoke: invoke
  };
  if (!isDialogOpen) {
    return props.children(childProps);
  }
  var label = props.label || translate("UserAction.ChangePartProcess.label", "Change Part Process");
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, props.children(childProps), /*#__PURE__*/_react["default"].createElement(_ChangePartFeatureDialog.ChangePartFeatureDialog, {
    label: label,
    timelineName: _Timeline.TIME_SERIES_PROCESS,
    isOpen: isDialogOpen,
    toggleDialog: toggleDialog,
    handleSubmit: changePartProcess
  }));
};